import { render, staticRenderFns } from "./AddEditItemDialog.vue?vue&type=template&id=46f396d2&scoped=true&"
import script from "./AddEditItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditItemDialog.vue?vue&type=style&index=0&id=46f396d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f396d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f396d2')) {
      api.createRecord('46f396d2', component.options)
    } else {
      api.reload('46f396d2', component.options)
    }
    module.hot.accept("./AddEditItemDialog.vue?vue&type=template&id=46f396d2&scoped=true&", function () {
      api.rerender('46f396d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/BuildingList/AddEditItemDialog.vue"
export default component.exports